import {z} from 'zod';

import {AssetProjectSchema} from '../assetProject';

export const AssetProjectReviewSchema = z.object({
	id: z.string(),
	projectId: z.number(),
	title: z.string(),
	description: z.string(),
	status: z.string(),
	assetId: z.number(),
	decision: z.string(),
	decisionDate: z.string(),
	project: AssetProjectSchema,
});

export type IAssetProjectReview = z.infer<typeof AssetProjectReviewSchema>;

export const AssetProjectReviewField = AssetProjectReviewSchema.keyof().enum;
